import React, { useState, useEffect, useCallback } from 'react';

const BASE = '/';
const apiFetch = (path, method = 'GET', body) => {
  const url = method === 'GET' ? `${BASE}${path}?_=${Date.now()}` : `${BASE}${path}`;
  return fetch(url, {
    method,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}`, 'Cache-Control': 'no-cache' },
    body: body ? JSON.stringify(body) : undefined,
  }).then(r => r.json());
};

function tempoAtras(iso) {
  const diff = (Date.now() - new Date(iso).getTime()) / 1000 / 60;
  if (diff < 60) return `${Math.round(diff)}min atrás`;
  if (diff < 1440) return `${Math.round(diff / 60)}h atrás`;
  return `${Math.round(diff / 1440)}d atrás`;
}

export default function Sugestoes() {
  const [sugestoes, setSugestoes] = useState([]);
  const [contatos, setContatos] = useState([]);
  const [autoGlobal, setAutoGlobal] = useState(false);
  const [carregando, setCarregando] = useState(true);
  const [editando, setEditando] = useState({});
  const [enviando, setEnviando] = useState({});

  const carregar = useCallback(async () => {
    const [dataSug, dataCont, dataGlobal] = await Promise.all([
      apiFetch('sugestoes'),
      apiFetch('sugestoes/contatos'),
      apiFetch('sugestoes/autoenvioglobal'),
    ]);
    if (Array.isArray(dataSug)) setSugestoes(dataSug);
    if (Array.isArray(dataCont)) setContatos(dataCont);
    if (dataGlobal?.ativo !== undefined) setAutoGlobal(dataGlobal.ativo);
    setCarregando(false);
  }, []);

  useEffect(() => {
    carregar();
    const t = setInterval(carregar, 5000);
    return () => clearInterval(t);
  }, [carregar]);

  const toggleGlobal = async (ativo) => {
    setAutoGlobal(ativo);
    await apiFetch('sugestoes/autoenvioglobal', 'POST', { ativo });
  };

  const toggleAutoEnvio = async (chave, ativo) => {
    setContatos(prev => prev.map(c => c.chave === chave ? { ...c, autoEnvio: ativo } : c));
    await apiFetch(`sugestoes/contatos/${encodeURIComponent(chave)}/autoenvia`, 'POST', { ativo });
  };

  const removerContato = async (chave) => {
    setContatos(prev => prev.filter(c => c.chave !== chave));
    await apiFetch(`sugestoes/contatos/${encodeURIComponent(chave)}/remover`, 'DELETE');
  };

  const reiniciarContato = async (chave) => {
    if (!window.confirm('Reiniciar o atendimento? O histórico da conversa será apagado.')) return;
    await apiFetch(`sugestoes/contatos/${encodeURIComponent(chave)}/reiniciar`, 'POST');
    carregar();
  };

  const enviar = async (sug) => {
    setEnviando(e => ({ ...e, [sug._id]: true }));
    const textoFinal = editando[sug._id] ?? sug.sugestao;
    if (editando[sug._id] !== undefined) {
      await apiFetch(`sugestoes/${sug._id}/editar`, 'PUT', { sugestao: textoFinal });
    }
    const resp = await apiFetch(`sugestoes/${sug._id}/enviar`, 'POST');
    if (resp.ok) {
      setSugestoes(prev => prev.filter(s => s._id !== sug._id));
    } else {
      alert('Erro ao enviar: ' + (resp.erro || 'tente novamente'));
    }
    setEnviando(e => ({ ...e, [sug._id]: false }));
  };

  const rejeitarTodas = async () => {
    if (!sugestoes.length) return;
    await Promise.all(sugestoes.map(s => apiFetch(`sugestoes/${s._id}`, 'DELETE')));
    setSugestoes([]);
  };

  const rejeitar = async (id) => {
    await apiFetch(`sugestoes/${id}`, 'DELETE');
    setSugestoes(prev => prev.filter(s => s._id !== id));
  };

  if (carregando) return <div style={{ padding: 40, textAlign: 'center', color: '#6b7280', fontSize: 13 }}>Carregando...</div>;

  return (
    <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', flexWrap: 'wrap' }}>

      {/* Coluna esquerda: contatos em atendimento */}
      <div style={{ width: 240, flexShrink: 0, minWidth: 200 }}>
        {/* Botão global */}
        <button onClick={() => toggleGlobal(!autoGlobal)}
          style={{
            width: '100%', marginBottom: 8, padding: '7px 12px',
            borderRadius: 4, border: 'none', cursor: 'pointer',
            background: autoGlobal ? '#16a34a' : '#6b7280',
            color: '#fff', fontWeight: 700, fontSize: 13,
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
          }}>
          {autoGlobal ? 'Modo Automático ON' : 'Modo Manual'}
        </button>
        {autoGlobal && (
          <div style={{ marginBottom: 8, padding: '5px 8px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 4, fontSize: 11, color: '#15803d', fontWeight: 600, textAlign: 'center' }}>
            IA respondendo todos automaticamente
          </div>
        )}

        <div style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', overflow: 'hidden' }}>
          <div style={{ background: '#e8edf2', borderLeft: '3px solid #0a1628', padding: '3px 10px' }}>
            <div style={{ fontWeight: 700, fontSize: 12, color: '#0a1628', textTransform: 'uppercase', letterSpacing: '0.04em' }}>Em Atendimento</div>
            <div style={{ fontSize: 10, color: '#9ca3af' }}>{autoGlobal ? 'Todos automáticos' : 'Ative individualmente'}</div>
          </div>

          {contatos.length === 0 ? (
            <div style={{ padding: '16px', textAlign: 'center', color: '#9ca3af', fontSize: 12 }}>
              Nenhum contato ativo
            </div>
          ) : (
            <div>
              {contatos.map(c => (
                <div key={c.chave} style={{ padding: '8px 10px', borderBottom: '1px solid #e8eaed', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 6 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 700, fontSize: 12, color: '#0a1628', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.nome}</div>
                    <div style={{ fontSize: 10, color: '#9ca3af', marginTop: 1 }}>{c.etapa}</div>
                    <div style={{ fontSize: 10, color: '#d1d5db', marginTop: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.ultimaMensagem}</div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                    {/* Toggle auto-envio */}
                    <button onClick={() => toggleAutoEnvio(c.chave, !c.autoEnvio)}
                      title={c.autoEnvio ? 'Auto-envio ativo' : 'Ativar envio automático'}
                      style={{ width: 36, height: 20, borderRadius: 10, background: c.autoEnvio ? '#16a34a' : '#d1d5db', border: 'none', cursor: 'pointer', position: 'relative', transition: 'background 0.2s' }}>
                      <span style={{ position: 'absolute', top: 2, left: c.autoEnvio ? 17 : 2, width: 16, height: 16, borderRadius: '50%', background: '#fff', boxShadow: '0 1px 3px rgba(0,0,0,0.2)', transition: 'left 0.2s', display: 'block' }} />
                    </button>
                    <button onClick={() => reiniciarContato(c.chave)} title="Reiniciar atendimento"
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#d1d5db', fontSize: 13, lineHeight: 1, padding: 2 }}
                      onMouseEnter={e => e.currentTarget.style.color = '#f59e0b'}
                      onMouseLeave={e => e.currentTarget.style.color = '#d1d5db'}>↺</button>
                    <button onClick={() => removerContato(c.chave)} title="Remover"
                      style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#d1d5db', fontSize: 14, lineHeight: 1, padding: 2 }}
                      onMouseEnter={e => e.currentTarget.style.color = '#ef4444'}
                      onMouseLeave={e => e.currentTarget.style.color = '#d1d5db'}>✕</button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {contatos.some(c => c.autoEnvio) && (
          <div style={{ marginTop: 8, padding: '6px 10px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 4, fontSize: 11, color: '#15803d', fontWeight: 600 }}>
            Auto-envio ativo para {contatos.filter(c => c.autoEnvio).length} contato(s)
          </div>
        )}
      </div>

      {/* Coluna direita: sugestões pendentes */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10 }}>
          <div>
            <h1 style={{ margin: 0, fontSize: 17, color: '#0a1628', fontWeight: 700 }}>Respostas Sugeridas pela IA</h1>
            <p style={{ margin: '2px 0 0', color: '#6b7280', fontSize: 12 }}>Revise, edite se quiser e envie</p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            {sugestoes.length > 0 && (
              <button onClick={rejeitarTodas} style={{ background: '#fef2f2', border: '1px solid #dc2626', borderRadius: 4, padding: '3px 10px', cursor: 'pointer', fontSize: 12, fontWeight: 600, color: '#dc2626' }}>
                Ignorar todas
              </button>
            )}
            <button onClick={carregar} style={{ background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 4, padding: '3px 10px', cursor: 'pointer', fontSize: 12, fontWeight: 600, color: '#374151' }}>
              Atualizar
            </button>
          </div>
        </div>

        {sugestoes.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px 0', color: '#9ca3af' }}>
            <div style={{ fontSize: 16, fontWeight: 600, color: '#374151' }}>Nenhuma mensagem pendente</div>
            <div style={{ fontSize: 12, marginTop: 4 }}>Quando um lead enviar mensagem, a IA irá sugerir uma resposta aqui</div>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {sugestoes.map(sug => (
              <div key={sug._id} style={{ background: '#fff', borderRadius: 4, border: '1px solid #c8d0da', padding: '10px 12px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                  <div>
                    <span style={{ fontWeight: 700, fontSize: 13, color: '#0a1628' }}>{sug.nome_contato}</span>
                    <span style={{ marginLeft: 8, fontSize: 11, color: '#6b7280' }}>{sug.telefone}</span>
                    <span style={{ marginLeft: 8, fontSize: 11, background: '#f0f4ff', color: '#3b82f6', padding: '1px 6px', borderRadius: 10, fontWeight: 600 }}>{sug.closer_nome?.split(' ')[0]}</span>
                  </div>
                  <span style={{ fontSize: 11, color: '#9ca3af' }}>{tempoAtras(sug.criado_em)}</span>
                </div>

                <div style={{ background: '#f9fafb', border: '1px solid #e8eaed', borderRadius: 3, padding: '6px 10px', marginBottom: 8 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: '#9ca3af', marginBottom: 3, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Mensagem recebida</div>
                  <div style={{ fontSize: 13, color: '#374151', lineHeight: 1.5 }}>{sug.mensagem_recebida}</div>
                </div>

                <div style={{ background: '#eff6ff', border: '1px solid #c7d2fe', borderRadius: 3, padding: '6px 10px', marginBottom: 8 }}>
                  <div style={{ fontSize: 10, fontWeight: 700, color: '#6366f1', marginBottom: 4, textTransform: 'uppercase', letterSpacing: '0.04em' }}>Sugestão da IA</div>
                  <textarea
                    value={editando[sug._id] ?? sug.sugestao}
                    onChange={e => setEditando(ed => ({ ...ed, [sug._id]: e.target.value }))}
                    rows={3}
                    style={{ width: '100%', border: 'none', background: 'transparent', resize: 'vertical', fontSize: 13, color: '#1f2937', fontFamily: 'inherit', lineHeight: 1.6, outline: 'none', boxSizing: 'border-box' }}
                  />
                </div>

                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => enviar(sug)} disabled={enviando[sug._id]}
                    style={{ flex: 1, background: enviando[sug._id] ? '#d1d5db' : '#16a34a', color: '#fff', border: 'none', borderRadius: 4, padding: '5px 0', fontSize: 12, fontWeight: 700, cursor: enviando[sug._id] ? 'default' : 'pointer' }}>
                    {enviando[sug._id] ? 'Enviando...' : 'Enviar pelo WhatsApp'}
                  </button>
                  <button onClick={() => rejeitar(sug._id)}
                    style={{ background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 4, padding: '5px 12px', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                    Ignorar
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
